import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    height: 100%;
    min-height: 256px;
    padding: 32px;
    background: #ffffff;
    border: 1px solid #dae7ed;
    border-radius: 12px;
    h3 {
        max-width: 230px;
    }
    p {
        max-width: 285px;
    }
`;
